import React, { useState, useEffect } from 'react';
import './ConfirmDialog.css';

function ConfirmDialog({ message, isOpen, onConfirm, onCancel }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      // Find the current expanded step
      const expandedStep = document.querySelector('.step-item.active');
      if (expandedStep) {
        // Get current scroll position
        const currentScroll = window.scrollY;
        // Get element position
        const elementPosition = expandedStep.getBoundingClientRect().top + currentScroll;
        // Adjust modal position to appear near the expanded step
        document.documentElement.style.setProperty('--modal-top', `${elementPosition}px`);
      } else {
        // Reset to default if no expanded step
        document.documentElement.style.setProperty('--modal-top', '0px');
      }
      
      setIsVisible(true);
    }
  }, [isOpen]);
  
  const handleConfirm = () => {
    setIsVisible(false);
    
    // Delay the actual closing to allow animation to complete
    setTimeout(() => {
      if (onConfirm) {
        onConfirm();
      }
    }, 300);
  };
  
  const handleCancel = () => {
    setIsVisible(false);
    
    // Delay the actual closing to allow animation to complete
    setTimeout(() => {
      if (onCancel) {
        onCancel();
      }
    }, 300);
  };
  
  // If not supposed to be open at all, don't render
  if (!isOpen && !isVisible) {
    return null;
  }
  
  return (
    <div className={`confirm-overlay ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="confirm-dialog">
        <div className="confirm-header">
          <div className="confirm-title">Confirm</div>
          <button className="close-button" onClick={handleCancel}>&times;</button>
        </div>
        <div className="confirm-body">
          <p className="confirm-message">{message}</p>
        </div>
        <div className="confirm-footer">
          <button className="secondary-button" onClick={handleCancel}>Cancel</button>
          <button className="primary-button" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;